angular.module('impactx.login').controller('LoginErrorDialogCtrl', [
    '$routeParams',
    'AppConfiguration',
    'TranslationService',
    '$redirect',
    '$location',
    '$mdDialog',
    'themeFactory',
    '$config',
    'error',
    'errorDescription',
    LoginErrorDialogController]);

function LoginErrorDialogController($routeParams, AppConfiguration, TranslationService, $redirect, $location, $mdDialog, themeFactory, $config, error,
                                    errorDescription) {
    var self = this;
    self.theme = themeFactory.getTheme();
    var errors = $routeParams.errors;
    if (error) {
        try {
            self.error = error;
            self.errorDescription = errorDescription;
            self.backToLoginLabel = TranslationService.get('backToLogin');
        } catch (e) {
            console.log(e);
            redirectToLoginPage();
        }
    }
    else {
        redirectToLoginPage();
    }

    self.redirect = function () {
        redirectToLoginPage();
    };

    function redirectToLoginPage() {
        $mdDialog.hide();
        $redirect.redirectTo(null, $config.loginRoute);
    }
}